export enum OverrideRuleType {
  ALWAYS = 'always',
  NEVER = 'never',
  CONDITIONAL = 'conditional',
}
